// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 419) return "static/css/419.1f94a0116067c7784c23.lib.css";
	if (chunkId === 823) return "static/css/823.1f363e900a47f20e15c1.css";
	// return url for filenames based on template
	return undefined;
};